module.exports = __webpack_public_path__ + "img/us_solution.6a13280f.jpg";